module.exports = __webpack_public_path__ + "static/media/surprise-meal2.e08c6cee.png";